/**
 * Returns uppercase initials for user's first and last name.
 * @param {string} firstname User's first name.
 * @param {string} lastName User's last name.
 * @return {string} User's uppercase initials.
 */
export const getUserInitials = (firstName, lastName) => {
  return firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase();
};
